import React from "react";
import Slider from "react-slick";
import "./categories.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import img1 from "../Assets/medicine.png";
import img2 from "../Assets/heart.png";
import img3 from "../Assets/brain.png";
import img4 from "../Assets/kidney.png";
import img5 from "../Assets/two-kidney.png";
import img6 from "../Assets/throught.png";
import img7 from "../Assets/two-heart.png";
import img8 from "../Assets/checking.png";
import img9 from "../Assets/mouth-checking.png";
import img10 from "../Assets/symbols.png";
import img11 from "../Assets/teeth.png";
import img12 from "../Assets/eye.png";
import img13 from "../Assets/leg.png";
import img14 from "../Assets/two-kidneys.png";
import img15 from "../Assets/op-theatre.png";
import img16 from "../Assets/baby.png";
import img17 from "../Assets/danger.png";
import img18 from "../Assets/hsp-symbol.png";
import img19 from "../Assets/bed-sleep.png";
import img20 from "../Assets/hand-frastrature.png";
import img21 from "../Assets/leg-fra.png";
import img22 from "../Assets/heart-baby.png";
import img23 from "../Assets/head.png";
import img24 from "../Assets/leg-treate.png";
import img25 from "../Assets/all-Food.png";
const data = [
  { img: img1, title: "General Medicine" },
  { img: img2, title: "Cardiology" },
  { img: img3, title: "Neurology" },
  { img: img4, title: "Gastroenterology" },
  { img: img5, title: "Nephrology" },
  { img: img6, title: "Endocrinology" },
  { img: img7, title: "Pulmonology" },
  { img: img8, title: "Dermatology" },
  { img: img9, title: "Anaesthesiology" },
  { img: img10, title: "Oncology" },
  { img: img11, title: "Dental Care" },
  { img: img12, title: "Ophthalmology" },
  { img: img13, title: "Orthopaedics" },
  { img: img14, title: "Urology" },
  { img: img15, title: "General Surgery" },
  { img: img16, title: "Obstetrics & Gynaecology" },
  { img: img17, title: "Infertility" },
  { img: img18, title: "Emergency Medicine" },
  { img: img19, title: "Critical Care" },
  { img: img20, title: "Trauma Care" },
  { img: img21, title: "Geriatrics" },
  { img: img22, title: "Pediatrics" },
  { img: img23, title: "ENT" },
  { img: img24, title: "Physiotherapy" },
  { img: img25, title: "Nutrition" },
];
const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow left-arrow" onClick={onClick}>
    &#10094;
  </div>
);

const NextArrow = ({ onClick }) => (
  <div className="custom-arrow right-arrow" onClick={onClick}>
    &#10095;
  </div>
);
function Categories() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };
  return (
    <div className="category-section">
      <h3>Precision In Every Speciality</h3>
      <p>Your health deserves nothing less than focused expertise</p>
      <Slider {...settings} className="category-slider">
        {data.map((ele, ind) => (
          <div className="health-card" key={ind}>
            <div className="icon-wrap">
              <img src={ele.img} alt={ele.title} />
            </div>
            <div className="health-title">{ele.title}</div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default Categories;
